var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('html',[_c('head'),_c('body',[_c('h2',[_vm._v("新增或编辑游戏服")]),_c('p',[_vm._v("一个游戏可以设置多个游戏服主机。可以对所有主机停服或者对单个主机停服。")])])])])
}]

export { render, staticRenderFns }